import styled from 'styled-components';
import { CssFuncs } from '../../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'central-drag-and-drop_container',
  displayName: 'CentralDragAndDrop.Container',
})`
  ${CssFuncs.css.absolute({ xy: '0px' })}
`;

const ContainerClassNames = {
  isDragging: 'is-dragging',
  isNotDragging: 'is-not-dragging',
};

export const CentralDragAndDropStyle = {
  Container,
  ContainerClassNames,
};
